import React, { Component } from 'react'
import './index.scss'

class MoveButton extends Component {
    render() {
        const { history, label, movePath } = this.props

        return (
            <div className='old-home-move-btn' onClick={() => history.push(movePath)}>
                {label}
            </div>
        )
    }
}

export default MoveButton